import { useQuery } from "@tanstack/react-query"
import {
  CORRESPONDENCE_INBOX_REFETCH_INTERVAL,
  correspondenceQueryKeys,
  getCorrespondenceUnreadCount,
} from "toptaal-shared"

export function useCorrespondenceUnreadCountQuery() {
  return useQuery({
    queryKey: correspondenceQueryKeys.unreadCount(),
    queryFn: getCorrespondenceUnreadCount,
    select: (data) => data.unreadCount,
    refetchInterval: CORRESPONDENCE_INBOX_REFETCH_INTERVAL,
  })
}
